import {useActions, useGetters, useMutators, useState} from './_default';
import {
    MAP_OBJECT_TYPE_GEOFENCE,
    MAP_OBJECT_TYPE_HISTORY_ARROW, MAP_OBJECT_TYPE_HISTORY_EVENT,
    MAP_OBJECT_TYPE_HISTORY_ROUTE,
    MAP_OBJECT_TYPE_HISTORY_STOP, MAP_OBJECT_TYPE_NAMES,
    MAP_OBJECT_TYPE_OBJECT,
    MAP_OBJECT_TYPE_POI,
    MAP_OBJECT_TYPE_ROUTE,
} from "@/js/constants.js";
import axios from "axios";
import {defaultMapSettings} from "@/js/Store/_map.js";
export default {
    namespaced: true,
    state: {
        ...useState(),
        settings: defaultMapSettings,
        controls: [],
        fullScreen: false,
        showTools: true,
        historyControlsActive: false,
        homeView: null,
        homeViewEnabled: false,
        controlsList: {
            default: [
                {
                    icon: 'icon-cluster',
                    name: 'cluster',
                    alias: 'm_objects_cluster',
                }, {
                    icon: 'icon-arrow-box',
                    name: 'fit_objects',
                    active: true,
                    static: true,
                }, {
                    icon: 'icon-object',
                    name: 'objects',
                    alias: 'm_objects',
                    loadMapObjects: true,
                    layer: MAP_OBJECT_TYPE_OBJECT,
                }, {
                    icon: 'icon-geofence',
                    name: 'geofences',
                    alias: 'm_geofences',
                    loadMapObjects: true,
                    layer: MAP_OBJECT_TYPE_GEOFENCE,
                }, {
                    icon: 'icon-routes',
                    name: 'routes',
                    alias: 'm_routes',
                    loadMapObjects: true,
                    layer: MAP_OBJECT_TYPE_ROUTE,
                }, {
                    icon: 'icon-pin',
                    name: 'poi',
                    alias: 'm_poi',
                    loadMapObjects: true,
                    layer: MAP_OBJECT_TYPE_POI,
                }, {
                    icon: 'icon-group-6979',
                    name: 'show_names',
                    alias: 'm_show_names',
                    layer: MAP_OBJECT_TYPE_NAMES,
                }, {
                    icon: 'icon-tails',
                    name: 'show_tails',
                    alias: 'm_show_tails',
                }, {
                    icon: 'icon-traffic',
                    name: 'show_traffic',
                    alias: 'm_traffic',
                }, {
                    icon: 'icon-dot-circle-o',
                    name: 'html_geolocation',
                    static: true,
                }
            ],

            history: [
                {
                    icon: 'icon-routes',
                    name: 'history_route',
                    title: 'front.route',
                    alias: 'history_control_route',
                    layer: MAP_OBJECT_TYPE_HISTORY_ROUTE,
                    active: true,
                }, {
                    icon: 'icon-object',
                    name: 'history_arrows',
                    title: 'front.arrows',
                    alias: 'history_control_arrows',
                    layer: MAP_OBJECT_TYPE_HISTORY_ARROW,
                    active: true,
                }, {
                    icon: 'icon-h-stop',
                    name: 'history_stops',
                    title: 'front.stops',
                    alias: 'history_control_stops',
                    layer: MAP_OBJECT_TYPE_HISTORY_STOP,
                    active: true,
                }, {
                    icon: 'icon-bell',
                    name: 'history_events',
                    title: 'front.events',
                    alias: 'history_control_events',
                    layer: MAP_OBJECT_TYPE_HISTORY_EVENT,
                    active: true,
                }
            ]
        },
    },
    getters: {
        ...useGetters(),
        ready: state => state.ready,
        controls: state => state.controls,
        fitObjectsControl: state => state.controls.find(control => control.name === 'fit_objects'),
        showTailControl: state => state.controls.find(control => control.name === 'show_tails'),
        showTrafficControl: state => state.controls.find(control => control.name === 'show_traffic'),
        clusterControl: state => state.controls.find(control => control.name === 'cluster'),
        objectsControl: state => state.controls.find(control => control.name === 'objects'),
        fullScreen: state => state.fullScreen,
        showTools: state => state.showTools,
        settings: state => state.settings,
        historyControlsActive: state => state.historyControlsActive,
        homeViewEnabled: state => state.homeViewEnabled,
        homeView: state => {
            if (!state.homeView) return;
            return {
                lat: state.homeView.center.lat,
                lng: state.homeView.center.lon,
                zoom: state.homeView.zoom
            };
        },
    },
    mutations: {
        ...useMutators(),

        enableHomeView(state, status) {
            state.homeViewEnabled = status;
        },

        settings(state, settings) {
            state.settings = Object.assign(state.settings, settings);
        },

        fullScreen(state, status) {
            state.fullScreen = status;
        },
        tools(state, status) {
            state.showTools = status;
        },
        ready(state, status) {
            state.ready = status;
        },
        removeFromList(state, layerGroup) {
            if (!layerGroup._map) return;
            layerGroup._map.removeLayer(layerGroup);
        },
        setDefaultControls(state) {
            state.historyControlsActive = false;
            state.controls = state.controlsList.default.filter(control => {
                return control.name !== 'html_geolocation' || state.settings.showHtmlGeolocation;
            });
        },
        setHistoryControls(state) {
            state.historyControlsActive = true;
            state.controls = state.controlsList.history;
        },
        setSharingControls(state) {
            state.controls = [...state.controlsList.default].filter((c) => {
                return ['geofences', 'routes', 'poi', 'objects'].indexOf(c.name) === -1;
            });
        },
        setControls(state, controls) {
            Object.keys(controls).forEach((key) => {
                let control = state.controlsList.default.find(c => c.name === key);
                if (!control) {
                    control = state.controlsList.history.find(c => c.name === key);
                }
                if (!control) return;
                control.active = controls[key] ? 1 : 0;
            });
        },

        disableFitBounds(state) {
            const control = state.controlsList.default.find(control => control.name === 'fit_objects');
            control.active = false;
        },
        enableFitBounds(state) {
            const control = state.controlsList.default.find(control => control.name === 'fit_objects');
            control.active = true;
        },

        enableClustering(state) {
            const control = state.controlsList.default.find(control => control.alias === 'm_objects_cluster');
            control.active = true;
        },

        disableTrafficControl(state) {
            const control = state.controlsList.default.find(control => control.name === 'show_traffic');
            control.active = false;
            control.disabled = true;
        },

        enableTrafficControl(state) {
            const control = state.controlsList.default.find(control => control.name === 'show_traffic');
            control.disabled = false;
        },

        setUserMapId(state, id) {
            state.settings.id = id;
        },

        setHomeView(state, data) {
            state.homeView = data;
        }
    },
    actions: {
        ...useActions(),
        changeControlStatus({ state }, control) {
            return new Promise((resolve, reject) => {
                if (!control.alias) return resolve();
                axios.put('/map/update', {
                    param: control.alias,
                    value: control.active
                }).then(resolve).catch(reject);
            });
        },

        storeHomeView({ state }, { center, zoom }) {
            return new Promise((resolve, reject) => {
                axios.post('/home-view', {
                    lat: center.lat,
                    lon: center.lng,
                    zoom
                }).then((response) => {
                    state.homeView = response.data;
                    resolve();
                }).catch(reject);
            });

        }
    },
}
